import React from "react";
import {YesNoRadio} from "../../kompetenceEvaluering/yesNoRadio";
import {SvarReadTypeProps} from "./svarReadTypeCompareMap";

export function BooleanReadSvar({evalueringSvar, renderId}: SvarReadTypeProps) {
    return (<YesNoRadio id={evalueringSvar.id + renderId} yesNo={evalueringSvar.booleanSvar} disabled/>)
}
